<template>
  <grid-container-fi
    :class="[
      'product-list-head-fi',
      `product-list-head-fi--${shopType}`,
      showVariantImage ? `product-list-head-fi--with-image` : '',
    ]"
    :container="false"
  >
    <div
      class="product-list-head-fi__item product-list-head-fi__item--totals"
      data-test="product-list-totals"
      :data-test-2="totalHits"
    >
      {{ totalHits ? $dict.get('product-List.Table.Product-Variants', [totalHits]) : '' }}
    </div>

    <div class="product-list-head-fi__group">
      <div
        v-for="(heading, idx) in categoryAttributes"
        :key="heading.AttributeKey"
        :class="[
          'product-list-head-fi__group-item',
          `product-list-head-fi__group-item--1-${maxHeadings}`,
          `attribute--${idx}`,
        ]"
      >
        <!-- eslint-disable vue/no-v-html -->
        <span
          class="product-list-head-fi__attribute-name"
          v-html="heading.AttributeName"
        />
        <p
          v-if="heading.technicalName"
          class="product-list-head-fi__technical-name--head-item"
          v-html="heading.technicalName"
        />
        <!-- eslint-disable vue/no-v-html -->
      </div>
    </div>
  </grid-container-fi>
</template>

<script>
import { mapGetters } from 'vuex';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';

export default {
  name: 'ProductListHeadFi',
  components: {
    GridContainerFi,
  },
  props: {
    categoryAttributes: {
      type: Array,
      required: true,
    },
    totalHits: {
      type: Number,
      default: 0,
    },
    showVariantImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      shopType: 'productList/getShopType',
      maxHeadings: 'productList/getMaxHeadings',
    }),
  },
};
</script>

<style scoped src="./product-list-head-fi" />
